export default __webpack_public_path__ + "static/media/FullNameLogo-vec.5aa806cf.png";